<template>
  <div class="home">
    <!--付款成功-->
    <van-loading class="home-loadings" v-show="showse" type="spinner" color="#1989fa" />
    <div v-if="!showse" class="home-van-dar">
      <p>
        <span class="home-van-dar-time" @click="show = true">
          {{date}}
          <van-icon name="arrow-down" size=".71875rem" />
        </span>
        <van-calendar
          v-model="show"
          @confirm="onConfirm"
          color="#0065F0"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <span>|</span>
        <span class="home-van-dar-span">{{(moneys/1000).toFixed(2)}}元</span>
      </p>
      <span class="home-van-span">{{count}}笔</span>
    </div>
    <!--分界线-->
    <div v-if="!showse">
      <!-- <p class="home-boundary"></p> -->
      <van-cell-group v-for="(item,i) in dada" :key="i">
        <div data-v-2c14c045 class="van-cell">
          <div data-v-2c14c045 class="van-cell__title van-cell__titles">
            <div class="home-boundary-img" v-if="item.pay_type=='2'">
              <img src="../../assets/image/Alipay.png" alt />
              <span class="home-boundary-sapn" data-v-2c14c045>支付成功</span>
            </div>
            <div class="home-boundary-img" v-if="item.pay_type=='1'">
              <img src="../../assets/image/Wechatpayment.png" alt />
              <span class="home-boundary-sapn" data-v-2c14c045>支付成功</span>
            </div>
          </div>
          <div data-v-2c14c045 class="van-cell__value van-cell__values">
            <span data-v-2c14c045>{{item.created_at}}</span>
          </div>
        </div>
        <van-cell
          class="van-cell-title-sapns"
          :title="item.business_name"
          :value="`+￥`+  Math.floor((item.pay_money/1000)  * 100) / 100"
        />
      </van-cell-group>
      <van-popup v-model="shows">
        <div class="fixation-img">
          <img :src="url" alt />
          <van-button class="fixation-img-button" type="info" round size="large">长按图片保存到手机</van-button>
        </div>
      </van-popup>
      <div class="fixation">
        <img @click="money" src="../../assets/image/Collectioncode.png" alt />
        <img @click="merchant" src="../../assets/image/BusinessCenter.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   businessOrderInfo,
//   businessOrderTopInfo
// } from "../../api/indent/indent";
import { getUserToken } from "@/utils/Cookie";
import { request } from "@/utils/https";
export default {
  name: "indent",
  data() {
    return {
      url: "",
      date: "",
      show: false,
      shows: false,
      showse: true,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(2038, 11, 31),
      count: "",
      moneys: "",
      dada: [],
      merchant_no: "",
      merchant_name: ""
    };
  },
  methods: {
    formatDate(date) {
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var dates = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return `${year}-${month}-${dates}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
      this.businessOrderInfos();
    },
    newdate() {
      var datetime = new Date();
      var year = datetime.getFullYear();
      var month =
        datetime.getMonth() + 1 < 10
          ? "0" + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1;
      var date =
        datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      this.date = `${year}-${month}-${date}`;
    },
    money() {
      this.shows = true;
    },
    merchant() {
      this.$router.push({
        path: "Personal",
        query: { types: "商家" }
      });
    },
    async businessOrderInfos() {
      this.moneys = "";
      this.count = "";
      this.dada = [];
      let data = {
        time: this.date
      };
      // console.log(data, "参数");
      let res = await request(
        "user/business/businessOrderTopInfo?token=" + getUserToken(),
        data
      );

      // console.log(res, "表头");
      if (res.data) {
        this.showse = false;
        this.moneys = res.data.money;
        this.count = res.data.count;
      }

      // businessOrderTopInfo(data).then(res => {
      //   console.log(res, "表头");
      //   if (res.data) {
      //     this.showse = false;
      //     this.moneys = res.data.money;
      //     this.count = res.data.count;
      //   }
      // });

      let list = await request(
        "user/business/businessOrderInfo?token=" + getUserToken(),
        data
      );
      // console.log(list, "时间");
      if (list.data) {
        this.showse = false;
        this.dada = list.data;
      }
      // businessOrderInfo(data).then(res => {
      //   console.log(res, "时间");
      //   if (res.data) {
      //     this.showse = false;
      //     this.dada = res.data;
      //   }
      // });
      let url = localStorage.getItem("url");
      if (!url) {
        let red = await request(
          "user/sms/builderQrcode?token=" + getUserToken(),
          {
            merchant_no: this.merchant_no,
            merchant_name: this.merchant_name
          }
        );
        if (red.data) {
          this.url = red.data.url;
          localStorage.setItem("url", red.data.url);
        }
      }
    }
  },
  beforeMount() {
    this.newdate();
    if (this.$route.query.merchant_no) {
      this.merchant_no = this.$route.query.merchant_no;
    }
    if (this.$route.query.merchant_name) {
      this.merchant_name = this.$route.query.merchant_name;
    }
  },
  mounted() {
    this.businessOrderInfos();
    let url = localStorage.getItem("url");
    if (url) {
      this.url = url;
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  /deep/ .van-popup {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 1.25rem;
  }
  .fixation-img {
    border-radius: 0;
    width: 17.71875rem;
    background-color: rgba(0, 0, 0, 0.7);
    img {
      width: 100%;
      border-radius: 1.25rem;
    }
    .fixation-img-button {
      margin-top: 2rem;
    }
  }
  .van-cell-title-sapns {
    span {
      font-size: 1rem;

      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  // position: relative;
  .home-van-dar {
    padding: 1.25rem 0.75rem;
    display: flex;
    p {
      text-align: center;
      font-size: 1.1875rem;

      font-weight: 500;
      .home-van-dar-time {
        font-size: 1.1875rem;

        font-weight: 400;
        color: rgba(0, 101, 240, 1);
      }
      .home-van-dar-span {
        font-size: 1.1875rem;

        font-weight: 500;

        color: rgba(51, 51, 51, 1);
      }
      flex: 1;
      float: left;
      span {
        float: left;
        padding: 0 0.53125rem;
      }
    }
  }
  .home-van-span {
    flex: 0.18;
    float: right;
    font-size: 1.1875rem;

    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .home-boundary {
    height: 0.625rem;
    background: rgba(246, 247, 249, 1);
  }
  .home-boundary-img {
    display: flex;

    align-items: center;
    img {
      width: 1.46875rem;
      height: 1.46875rem;
      margin-right: 0.671875rem;
    }
  }
  .home-boundary-sapn {
    font-size: 0.9375rem;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 550 !important;
    color: rgba(51, 51, 51, 1);
  }
  .van-cell::after {
    border-bottom: 0px solid #ebedf0;
  }
  .van-cell-group {
    padding: 1.46875rem 0.75rem 1.25rem 0.625rem;
    .van-cell:first-child {
      padding: 0 0 0.5625rem 0;
    }
    .van-cell {
      padding: 0;
      img {
        width: 1.59375rem;
        height: 1.40625rem;
        margin-right: 0.671875rem;
      }
      .van-cell__title {
        span {
          font-size: 1rem;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
      .van-cell__titles {
        span {
          font-size: 0.9375rem;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
      }
      .van-cell__value {
        font-size: 1rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(253, 147, 6, 1);
      }

      .van-cell__values {
        font-size: 0.75rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .fixation {
    width: 3.4375rem;
    right: 0.71875rem;
    position: fixed;
    bottom: 3.65625rem;
    img {
      width: 3.4375rem;
      padding-bottom: 0.25rem;
      float: left;
    }
  }
}
</style>
